import * as React from 'react';
import styled from 'styled-components';

interface LoadingPanelProps {
	message?: string;
}

const defaultProps: LoadingPanelProps = {
	message: 'Loading',
};

export default function LoadingPanel(props: LoadingPanelProps) {
	const { message } = { ...defaultProps, ...props };
	return (
		<Container className="noselect">
			<i className="fas fa-4x fa-diagnoses fa-fw m-3"></i>
			<span>{message}</span>
			<i className="fas fa-spinner fa-pulse fa-2x mt-3 fa-fw" />
		</Container>
	);
}

const Container = styled.div`
	height: 100%;
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	span {
		font-size: 20px;
		font-weight: 700;
	}
`;
